import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Stateless function representing an accident icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AccidentIcon width={24} />
 */
const AccidentIcon = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d={`M16.89,4.47l1.38,1.38l2.07,2.07l1.38,1.38c0.38,0.38,0.38,1,0,1.38l-0.69,0.69c-0.38,0.38-1,0.38-1.38,0l-0.69-0.69
                l-8.28,8.28l0.69,0.69c0.38,0.38,0.38,1,0,1.38l-0.69,0.69c-0.38,0.38-1,0.38-1.38,0l-1.38-1.38l-2.07-2.07l-1.38-1.38
                c-0.38-0.38-0.69-1.13-0.69-1.66v-0.81c0-0.54-0.17-1.38-0.38-1.87L2.1,9.51C1.89,9.02,2.03,8.3,2.4,7.92L7.92,2.4
                C8.3,2.03,9.02,1.89,9.51,2.1l3.03,1.3c0.49,0.21,1.34,0.38,1.87,0.38h0.81C15.76,3.78,16.51,4.09,16.89,4.47z M6.2,15.16
                c-0.57,0.57-0.57,1.5,0,2.07c0.57,0.57,1.5,0.57,2.07,0c0.57-0.57,0.57-1.5,0-2.07C7.7,14.59,6.77,14.59,6.2,15.16z M3.78,8.61
                C3.59,8.8,3.52,9.16,3.61,9.41l1.37,3.57c0.1,0.25,0.33,0.3,0.52,0.11l7.59-7.59c0.19-0.19,0.14-0.42-0.11-0.52L9.41,3.61
                c-0.25-0.1-0.61-0.02-0.8,0.17L3.78,8.61z M15.16,11.03c-0.19-0.19-0.5-0.19-0.69,0l-3.45,3.45c-0.19,0.19-0.19,0.5,0,0.69l0,0
                c0.19,0.19,0.5,0.19,0.69,0l3.45-3.45C15.35,11.53,15.35,11.22,15.16,11.03L15.16,11.03z M18,7h-1V6h-1v1h-1v1h1v1h1V8h1V7z`}
        />
    </SvgIcon>
)

export { AccidentIcon }
